const labels = require('./labels').default;

export const getLabel = (key) => (labels[key] ? labels[key] : `*${key}`);
